<template>
  <div class="main-container">
    <div v-if="!iframeUrl">
      <div class="button-container" v-for="(group, groupIndex) in groupedCards" :key="groupIndex">
        <v-card v-for="(card, cardIndex) in group" :key="cardIndex" @click="handleButtonClick(card)">
          <div class="card-content">
            <v-icon class="card-icon">{{ card.icon }}</v-icon>
            <v-card-title>{{ card.title }}</v-card-title>
          </div>
        </v-card>
      </div>
    </div>
    <div v-else>
      <group-card :icon="selectedCard.icon" :title="selectedCard.title" padded>
        <div class="back-button">
            <md-button class="md-primary md-sm" @click="goBack">
              <md-icon>arrow_back</md-icon>
              <span>Go To Main Metabase Reporting</span>
            </md-button>
        </div>
        <!-- When more than 1 dashboard in card -->
        <div v-if="selectedCard.tabs && selectedCard.tabs.length > 1 && iframeUrl">
          <md-tabs class="md-secondary section-tabs" md-alignment="centered" @md-changed="handleTabChange">
            <md-tab v-for="tab in selectedCard.tabs" :key="tab.id" :id="tab.id" :md-label="tab.title">
              <iframe
                v-if="tab.iframeUrl === iframeUrl"
                :src="tab.iframeUrl"
                frameborder="0"
                class="i-frame"
                allowtransparency
              ></iframe>
            </md-tab>
          </md-tabs>
        </div>
        <!-- 1 single dashboard in card -->
        <div v-if="iframeUrl && selectedCard.tabs.length === 1">
          <iframe
            :src="iframeUrl"
            frameborder="0"
            class="i-frame"
            allowtransparency
          ></iframe>
        </div>
        <div v-if="showError">
          <md-empty-state
            md-icon="close"
            md-label="Failed to retrieve report"
            md-description="Please refresh the page."
          />
        </div>
      </group-card>
    </div>
  </div>
</template>

<script>
import { GroupCard } from "@/components";

export default {
  components: {
    GroupCard
  },
  data() {
    return {
      cards: [
        { title: 'Accounts', icon: 'supervised_user_circle', tabs: [
          {
            id: 'tab-accounts',
            title: 'Accounts',
            // Billings report
            iframeUrl: 'https://meta.zink.com.au/public/dashboard/a9102b15-def0-4fe3-a3e4-783bb5cfd657'
          }
        ]},
        { title: 'Sales', icon: 'paid', tabs: [
          {
            id: 'tab-sales',
            title: 'Sales',
            // Overall sales performance
            iframeUrl: 'https://meta.zink.com.au/public/dashboard/98a11465-f356-4b8e-8000-8cf776cb7bca'
          }
        ]},
        { title: 'Lender', icon: 'business', tabs: [
          {
            id: 'tab-lender',
            title: 'Lender',
            // Lender reporting
            iframeUrl: 'https://meta.zink.com.au/public/dashboard/443e1eab-3604-4453-9da1-a14f7197bd99'
          }
        ]},
        { title: 'Zink Uptime', icon: 'network_check', tabs: [
          {
            id: 'tab-zink-uptime',
            title: 'Zink-uptime',
            // Kuma Service
            iframeUrl: 'https://uptime.zink.com.au/status/zink'
          }
        ]},
        { title: 'Call Center', icon: 'call', tabs: [
          {
            id: 'tab-call-center',
            title: 'Call Center',
            // Call Centre dashboard
            iframeUrl: 'https://meta.zink.com.au/public/dashboard/537d5e83-7260-44ab-925a-6a6cd6c3582a'
          }
        ]},
        { title: 'Marketing', icon: 'query_stats', tabs: [
          {
            id: 'tab-lead-funnel',
            title: 'Lead Funnel',
            // Lead Funnel - Application count
            iframeUrl: 'https://meta.zink.com.au/public/dashboard/66caddc5-72a0-4b97-9e05-9de0eff34c39'
          },
          {
            id: 'tab-auction-reporting',
            title: 'Auction Reporting',
            // Auction reporting - Auction Cycle data
            iframeUrl: 'https://meta.zink.com.au/public/dashboard/6d4e84b9-f138-4eac-b40e-ed4e2d455270'
          }
        ]},
      ],
      iframeUrl: null,
      showError: false,
      selectedCard: { title: '', icon: '', tabs: []},
    };
  },
  computed: {
    groupedCards() {
      const groupSize = 3;
      const grouped = [];
      for (let i = 0; i < this.cards.length; i += groupSize) {
        grouped.push(this.cards.slice(i, i + groupSize));
      }
      return grouped;
    },
  },
  methods: {
    handleButtonClick(card) {
      this.selectedCard = card;
      this.iframeUrl = card.tabs[0].iframeUrl;
    },
    handleTabChange(tabId) {
      if (tabId && this.selectedCard && this.selectedCard.tabs) {
        const selectedTab = this.selectedCard.tabs.find(tab => tab.id === tabId);
        this.selectedCard.tabs.forEach(tab => {
          tab.selected = tab === selectedTab;
        });
        this.iframeUrl = selectedTab ? selectedTab.iframeUrl : null;
      }
    },
    goBack() {
        this.iframeUrl = null;
        this.selectedCard = { title: '', icon: '' };
      },
    },
  };
</script>

<style scoped lang="scss">
@import '../assets/scss/theme.scss';
@import '../assets/scss/md-custom/_ausloans-colors.scss';
.main-container {
  display: flex;
  flex-direction: column;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 350px;
  margin-top: 10vh;
}

.back-button {
  position: relative;
  padding-bottom: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}

.v-card {
  height: 270px;
  width: 25vw;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-icon {
  font-size: 70px;  /* Adjusted font size */
}

.v-card__title {
  font-weight: 500;
  font-size: 26px;
  font-family: Helvetica, Arial, sans-serif !important
}

.i-frame {
  height: 80vh;
  width: 100%;
}

.section-tabs {
    margin: 25px;

    &::v-deep .md-tabs-navigation {
        position: sticky;
        top: 0px;
        z-index: 2;
        background: white !important;

        & .md-active {
            background-color: $ausloans-blue !important;
            color: white !important;
        }
    }

    &::v-deep .md-tabs-content {
        background: transparent !important;

        & .md-tab {
            padding-left: 0px;
            padding-right: 0px;
        }
    }
}

</style>
